import * as stylex from "@stylexjs/stylex";
import { fonts } from "@softmax/design-system/tokens.stylex";
import { isPreviewHost } from "../../release/preview-host";
import type { ReplayTimingController } from "./playback/use-replay-timing";

const styles = stylex.create({
  diagnostics: {
    position: "absolute",
    bottom: 4,
    left: 4,
    zIndex: 20,
    pointerEvents: "none",
    borderRadius: 3,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    paddingInline: 6,
    paddingBlock: 2,
    color: "rgba(255, 255, 255, 0.8)",
    fontFamily: fonts.mono,
    fontSize: 10,
    lineHeight: 1,
    whiteSpace: "nowrap",
  },
  runtimeDiagnostic: { color: "#dc997b" },
});

export function ReplayDeliveryBadge({
  enabled,
  badge,
}: {
  enabled: boolean;
  badge: ReplayTimingController["badge"];
}) {
  if (!enabled || !badge || !isPreviewHost()) return null;

  return (
    <div
      {...stylex.props(
        styles.diagnostics,
        badge.delivery === "runtime" && styles.runtimeDiagnostic,
      )}
    >
      {badge.delivery === "runtime"
        ? "runtime — re-runs the game"
        : badge.delivery}
      {badge.firstPaintMs != null ? " · " + badge.firstPaintMs + "ms" : null}
    </div>
  );
}
